<template>
  <div class="content-center full-height">
    <div class="background-black">
      <div class="p-5 flex justify-center items-center">
        <a href="/"><img src="/images/logo_testo.png" /></a>
      </div>

      <div class="mt-1 px-8 py-3 flex justify-center items-center">
        <a href="https://streetstock.it">
          <button class="btn-indigo sconto-button" type="submit">OTTIENI LO SCONTO</button>
        </a>
      </div>
      <div style="padding: 30px 10px" class="p-2 flex justify-center items-center">
        <span class="text-white text-center font-bold text-3xl">Vieni a trovarci a: </span>
      </div>
      <div class="mt-1 px-8 py-3 flex justify-center items-center">
        <a href="https://maps.app.goo.gl/mxcRCAkPxPXxVcUr9">
          <button class="btn-indigo social-button" type="submit">ROMA</button>
        </a>
      </div>
      <div class="mt-1 px-8 py-3 flex justify-center items-center">
        <a href="https://maps.app.goo.gl/kpPFpGp4xsMbqGWZ6">
          <button class="btn-indigo social-button" type="submit">PERUGIA</button>
        </a>
      </div>
      <div class="mt-1 px-8 py-3 flex justify-center items-center">
        <a href="https://maps.app.goo.gl/Y9zK1BpUsyTmNZNk6">
          <button class="btn-indigo social-button" type="submit">BARI</button>
        </a>
      </div>
      <div class="mt-1 px-8 py-3 flex justify-center items-center">
        <a href="https://maps.app.goo.gl/qCACBKPgzVrQUcQw8">
          <button class="btn-indigo social-button" type="submit">TRANI</button>
        </a>
      </div>
      <div class="mt-1 px-8 py-3 flex justify-center items-center">
        <a href="https://maps.app.goo.gl/VT29xJLqPNqMT41V9">
          <button class="btn-indigo social-button" type="submit">SAN BENEDETTO DEL TRONTO</button>
        </a>
      </div>
      <div class="mt-1 px-8 py-3 flex justify-center items-center">
        <a href="">
          <button class="btn-indigo social-button" type="submit">MAGLIE</button>
        </a>
      </div>
      <div class="mt-1 px-8 py-3 flex justify-center items-center">
        <a href="https://maps.app.goo.gl/76pvXNWHCFWTaSLC8">
          <button class="btn-indigo social-button" type="submit">OSTUNI</button>
        </a>
      </div>
      <div class="mt-1 px-8 py-3 flex justify-center items-center">
        <a href="https://maps.app.goo.gl/rMHmRwh4xzVcngFDA">
          <button class="btn-indigo social-button" type="submit">GRAVINA IN PUGLIA</button>
        </a>
      </div>
      <div class="mt-1 px-8 py-3 flex justify-center items-center">
        <a href="https://maps.app.goo.gl/fJ3cwuKALuaeA13o9">
          <button class="btn-indigo social-button" type="submit">SAN GIOVANNI ROTONDO</button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      options: {},
    }
  },
}
</script>

<style scoped>
/* Aggiungere altezza per coprire tutta la pagina */
.full-height {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* Sfondo nero per coprire tutta l'altezza */
.background-black {
  background-color: #000;
  flex-grow: 1;
  width: 100%;
}

/* Stile dei pulsanti per garantire uniformità */
.social-button {
  padding: 15px 20px;
  width: 220px; /* Larghezza uniforme per tutti i pulsanti */
  text-align: center;
  word-wrap: break-word; /* Consenti il testo su più righe */
  white-space: normal; /* Permetti al testo di andare su più righe */
  height: auto; /* Adatta l'altezza ai contenuti */
  display: flex;
  justify-content: center;
  align-items: center; /* Centra il testo verticalmente e orizzontalmente */
}

.sconto-button {
  padding: 15px 20px; /* Riduci il padding per uniformità */
  width: 220px; /* Mantieni la larghezza fissa */
  text-align: center;
}
</style>
